import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDPTKO1c-K2wzRtV7swJDvpxuF7n_fOniM",
  authDomain: "recorridosvirtualesfacpya.firebaseapp.com",
  projectId: "recorridosvirtualesfacpya",
  storageBucket: "recorridosvirtualesfacpya.appspot.com",
  messagingSenderId: "375626733327",
  appId: "1:375626733327:web:f728d87ae8aeacceb7907a"
};

firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const functions = firebase.functions();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const timestamp = firebase.firestore.FieldValue;
export const taskEvent = firebase.storage.TaskEvent;

// if (process.env.NODE_ENV === "development") {
//   auth.useEmulator("http://localhost:9099", { disableWarnings: true });
//   firestore.useEmulator("localhost", 8080);
//   functions.useEmulator("localhost", 5001);
// }



// WEBPACK FOOTER //
// ./src/firebase.js